export default __webpack_public_path__ + "static/media/60_mobile.09740c35.jpg";